// Avisos breves ("Guardado", "Llamada transferida"...). Entran con resorte y salen solos.
import { useEffect, useRef, useSyncExternalStore } from 'react';

import { Icon } from '../lib/icons';
import { enter, SpringValue, reducedMotion } from '../lib/spring';

type Toast = { id: number; texto: string; tipo: 'ok' | 'info' | 'error' };
let lista: Toast[] = [];
let seq = 0;
const subs = new Set<() => void>();
const emit = () => subs.forEach((s) => s());

export function toast(texto: string, tipo: Toast['tipo'] = 'ok') {
  const t = { id: ++seq, texto, tipo };
  lista = [...lista, t].slice(-4);
  emit();
  setTimeout(() => dismiss(t.id), tipo === 'error' ? 6000 : 3200);
}

function dismiss(id: number) {
  lista = lista.filter((t) => t.id !== id);
  emit();
}

function ToastItem({ t }: { t: Toast }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => enter(ref.current, { y: 16, scale: 0.96 }), []);
  return (
    <div
      ref={ref}
      className={`toast ${t.tipo}`}
      role={t.tipo === 'error' ? 'alert' : 'status'}
      onClick={() => {
        const el = ref.current;
        if (!el || reducedMotion()) return dismiss(t.id);
        new SpringValue(1, (p) => {
          el.style.opacity = String(p);
          el.style.transform = `translateY(${(1 - p) * 10}px)`;
        }).go(0, { response: 0.25, done: () => dismiss(t.id) });
      }}
    >
      <Icon name={t.tipo === 'error' ? 'alert' : t.tipo === 'info' ? 'info' : 'check'} />
      <span>{t.texto}</span>
    </div>
  );
}

export function Toasts() {
  const items = useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    () => lista,
  );
  return (
    <div className="toasts" aria-live="polite">
      {items.map((t) => (
        <ToastItem key={t.id} t={t} />
      ))}
    </div>
  );
}
